"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.sort");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _shopList = require("@/api/shop/shopList");
var _goods = require("@/api/goods/goods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'goodsMakeMethod',
  directives: {
    waves: _waves.default
  },
  props: {
    goodsId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      resPath: process.env.VUE_IMAGE_PATH,
      storeQuery: {
        keywords: null
      },
      storeData: [{
        children: []
      }],
      listLoading: false,
      addGoodsUnitVisible: false,
      addGoodsUnitForm: {
        storeId: null,
        goodsId: null,
        unitId: null,
        price: null,
        sort: 0
      },
      addGoodsUnitRules: {
        unitId: [{
          required: true,
          message: '请选择规格',
          trigger: 'change'
        }],
        price: [{
          required: true,
          message: '请输入规格价格',
          trigger: 'blur'
        }]
      },
      unitList: [],
      goodsUnitDataList: [],
      addGoodsMakeMethodVisible: false,
      addGoodsMakeMethodForm: {
        unitGoodsId: null,
        makeMethodIds: []
      },
      makeMethods: [],
      goodsName: ''
    };
  },
  created: function created() {
    this.init();
  },
  watch: {
    goodsId: function goodsId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.init();
      }
    }
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    init: function () {
      var _init = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.handleStoreFilter();
              (0, _goods.getUnitList)().then(function (res) {
                _this.unitList = res.data;
              });
              (0, _goods.getMakeMethodTree)().then(function (res) {
                _this.makeMethods = res.data;
              });
              // 获取商品名称
              if (this.goodsId) {
                (0, _goods.getById)(this.goodsId).then(function (res) {
                  if (res && res.data) {
                    _this.goodsName = res.data.goodsName;
                  }
                });
              }
              this.handleStoreSelect(-1);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    handleSortChange: function handleSortChange(data, row) {
      var _this2 = this;
      // 通过 row 对象的 children 字段判断层级
      var isFirstLayer = row.children !== null && Array.isArray(row.children);
      if (isFirstLayer) {
        // 第一层节点 - 分类节点 (如"温度"、"加料")
        // TODO: 调用更新分类排序的 API
        (0, _goods.updateGoodsMakeMethodType)({
          id: data.id,
          sort: data.sort
        }).then(function (res) {
          _this2.$message.success('排序更新成功');
          _this2.handleStoreSelect(_this2.addGoodsUnitForm.storeId);
        }).catch(function (error) {
          _this2.$message.error('排序更新失败');
        });
      } else {
        // 第二层节点 - 具体选项 (如"正常冰"、"少冰")
        (0, _goods.updateGoodsMakeMethod)({
          id: data.id,
          sort: data.sort
        }).then(function (res) {
          _this2.$message.success('排序更新成功');
          _this2.handleStoreSelect(_this2.addGoodsUnitForm.storeId);
        }).catch(function (error) {
          _this2.$message.error('排序更新失败');
        });
      }
    },
    handleGoodsUnitDelete: function handleGoodsUnitDelete(id) {
      var _this3 = this;
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _goods.deleteGoodsUnit)({
          id: id
        }).then(function (res) {
          _this3.$message.success('操作成功');
          _this3.handleStoreSelect(_this3.addGoodsUnitForm.storeId);
        });
      }).catch(function () {});
    },
    handleGoodsUnitEdit: function handleGoodsUnitEdit(unit) {
      this.addGoodsUnitForm = {
        id: unit.id,
        storeId: unit.storeId,
        goodsId: unit.goodsId,
        unitId: unit.unitId,
        price: unit.price,
        sort: unit.sort
      };
      this.addGoodsUnitVisible = true;
    },
    handleMakeMethodDelete: function handleMakeMethodDelete(row) {
      var _this4 = this;
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var deleteIds = [];
        if (row.children) {
          for (var i = 0; i < row.children.length; i++) {
            deleteIds.push(row.children[i].data.id);
          }
        } else {
          deleteIds.push(row.data.id);
        }
        (0, _goods.deleteGoodsMakeMethod)({
          ids: deleteIds
        }).then(function (res) {
          _this4.$message.success('操作成功');
          _this4.handleStoreSelect(_this4.addGoodsUnitForm.storeId);
        });
      }).catch(function () {});
    },
    getRowKey: function getRowKey(row) {
      return row.id + '_' + row.data.name + '_' + row.data.code;
    },
    saveGoodsMakeMethod: function saveGoodsMakeMethod() {
      var _this5 = this;
      this.$refs.addGoodsMakeMethodFormRef.validate(function (valid) {
        if (valid) {
          _this5.listLoading = true;
          (0, _goods.addGoodsMakeMethod)(_this5.addGoodsMakeMethodForm).then(function (res) {
            _this5.$message.success('操作成功');
            _this5.addGoodsMakeMethodVisible = false;
            _this5.handleStoreSelect(_this5.addGoodsUnitForm.storeId);
            _this5.listLoading = false;
          });
        }
      });
    },
    handleAddGoodsMakeMethod: function handleAddGoodsMakeMethod(goodsUnitId) {
      this.addGoodsMakeMethodForm.unitGoodsId = goodsUnitId;
      this.addGoodsMakeMethodVisible = true;
    },
    handleDefaultFlag: function handleDefaultFlag(id, defaultFlag) {
      var _this6 = this;
      (0, _goods.updateGoodsUnit)({
        id: id,
        defaultFlag: defaultFlag
      }).then(function (res) {
        _this6.handleStoreSelect(_this6.addGoodsUnitForm.storeId);
        _this6.$message.success('操作成功');
      });
    },
    handleDisplayFlag: function handleDisplayFlag(id, type, displayFlag) {
      var _this7 = this;
      if ('goodsUnit' === type) {
        (0, _goods.updateGoodsUnit)({
          id: id,
          displayFlag: displayFlag
        }).then(function (res) {
          _this7.$message.success('操作成功');
        });
      } else if ('goodsMakeMethod' === type) {
        (0, _goods.updateGoodsMakeMethod)({
          id: id,
          displayFlag: displayFlag
        }).then(function (res) {
          _this7.$message.success('操作成功');
        });
      }
    },
    handleAddGoodsUnit: function handleAddGoodsUnit() {
      var _this8 = this;
      this.addGoodsUnitForm = {
        storeId: this.addGoodsUnitForm.storeId,
        goodsId: this.addGoodsUnitForm.goodsId,
        unitId: null,
        price: null,
        sort: 0
      };
      this.addGoodsUnitVisible = true;
      this.$nextTick(function () {
        if (_this8.$refs.addGoodsUnitFormRef) {
          _this8.$refs.addGoodsUnitFormRef.clearValidate();
        }
      });
    },
    saveGoodsUnit: function saveGoodsUnit() {
      var _this9 = this;
      this.$refs.addGoodsUnitFormRef.validate(function (valid) {
        if (valid) {
          _this9.listLoading = true;
          if (_this9.addGoodsUnitForm.id) {
            (0, _goods.updateGoodsUnit)(_this9.addGoodsUnitForm).then(function () {
              _this9.$message.success('操作成功');
              _this9.addGoodsUnitVisible = false;
              _this9.handleStoreSelect(_this9.addGoodsUnitForm.storeId);
              _this9.listLoading = false;
            }).catch(function () {
              _this9.$message.error('保存失败');
            });
          } else {
            (0, _goods.addGoodsUnit)(_this9.addGoodsUnitForm).then(function () {
              _this9.$message.success('操作成功');
              _this9.addGoodsUnitVisible = false;
              _this9.handleStoreSelect(_this9.addGoodsUnitForm.storeId);
              _this9.listLoading = false;
            }).catch(function () {
              _this9.$message.error('保存失败');
            });
          }
        }
      });
    },
    handleStoreFilter: function handleStoreFilter() {
      var _this0 = this;
      (0, _shopList.queryStore)(this.storeQuery).then(function (res) {
        _this0.storeData = res.data;
      });
    },
    handleStoreSelect: function handleStoreSelect(storeId) {
      var _this1 = this;
      this.addGoodsUnitForm.storeId = storeId;
      this.addGoodsUnitForm.goodsId = this.goodsId;
      (0, _goods.getGoodsMakeMethodInfo)({
        goodsId: this.goodsId,
        storeId: storeId
      }).then(function (res) {
        _this1.goodsUnitDataList = res.data;
      });
    }
  }
};